import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Switch } from '@/components/ui/switch'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useList } from '@/hooks/useList'
import { usePersistentState } from '@/hooks/usePersistentState'

interface Plat {
  id: string
  name: string
}

interface User {
  id: string
  username: string
}

export default function Account() {
  const [plats] = useList<Plat>('plat')
  const [users] = useList<User>('user')
  const [filters, setFilter, clearFilters] = usePersistentState<Record<string, any>>(
    'admin:account:filters',
    {},
  )

  const handleResetFilters = () => {
    clearFilters()
  }

  const fields: ManageField[] = [
    {
      desc: '平台',
      field: 'plat',
      NoShowInTable: true,
    },
    {
      desc: 'code',
      field: 'current',
    },
    {
      desc: '备注名',
      field: 'remarks_name',
    },
    {
      desc: '余额',
      field: 'total_account',
    },
    {
      desc: '已充值',
      field: 'level_integral',
    },
    {
      desc: '绑定手机号',
      field: 'phone',
    },
    {
      desc: '账号',
      field: 'account_id',
    },
    {
      desc: 'user',
      field: 'user',
    },
    {
      desc: 'vip',
      field: 'vip',
    },
    {
      desc: 'token',
      field: 'token',
      NoShowInTable: true,
    },
    {
      desc: '过期',
      field: 'warning',
      valuePropName: 'checked',
      Comp: <Switch />,
      render: (val) => (val ? '是' : '否'),
    },
    {
      desc: '封禁',
      field: 'error',
      valuePropName: 'checked',
      Comp: <Switch />,
      render: (val) => (val ? '是' : '否'),
    },
    {
      desc: '更新日期',
      field: 'update_time',
    },
  ]

  const filterUI = (
    <div className="flex items-center gap-4 flex-wrap">
      <div className="flex items-center gap-2">
        <span className="text-sm">plat:</span>
        <Select
          value={filters.plat || undefined}
          onValueChange={(val) => {
            if (val) {
              setFilter({ ...filters, plat: val })
            } else {
              const newFilters = { ...filters }
              delete newFilters.plat
              setFilter(newFilters)
            }
          }}
        >
          <SelectTrigger className="w-[120px]">
            <SelectValue placeholder="选择平台" />
          </SelectTrigger>
          <SelectContent>
            {plats.map((plat) => (
              <SelectItem key={plat.id} value={plat.name}>
                {plat.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm">user:</span>
        <Select
          value={filters.user || undefined}
          onValueChange={(val) => {
            if (val) {
              setFilter({ ...filters, user: val })
            } else {
              const newFilters = { ...filters }
              delete newFilters.user
              setFilter(newFilters)
            }
          }}
        >
          <SelectTrigger className="w-[120px]">
            <SelectValue placeholder="选择用户" />
          </SelectTrigger>
          <SelectContent>
            {users.map((user) => (
              <SelectItem key={user.id} value={user.username}>
                {user.username}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm">phone:</span>
        <Input
          className="w-[150px]"
          placeholder="输入手机号"
          value={filters.phone || ''}
          onChange={(e) => {
            const newFilters = { ...filters }
            if (e.target.value) {
              newFilters.phone = e.target.value
            } else {
              delete newFilters.phone
            }
            setFilter(newFilters)
          }}
        />
      </div>

      <div className="flex items-center gap-2">
        <span className="text-sm">deviceId:</span>
        <Input
          className="w-[150px]"
          placeholder="输入设备ID"
          value={filters.deviceId || ''}
          onChange={(e) => {
            const newFilters = { ...filters }
            if (e.target.value) {
              newFilters.deviceId = e.target.value
            } else {
              delete newFilters.deviceId
            }
            setFilter(newFilters)
          }}
        />
      </div>
    </div>
  )

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">账号管理</h1>
      <ManageTable fields={fields} filter={filterUI} filters={filters} collect="account" onResetFilters={handleResetFilters} />
    </div>
  )
}
